'use client';

import { FacetsViewModel } from '@/types/api';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import { setBodyOverflowHidden } from '@/app/_utils/set-body-overflow';
import { STOCK_FACET_KEY } from './constants';
import { Button } from '../button';
import { IconTrash } from '../icons';
interface Props {
  className?: string;
}
export function RemoveAllFilters({
  className
}: Props) {
  const {
    anyFiltersApplied,
    allFacets,
    deactivateFacets,
    filterChangeByUserRef
  } = usePLPFacetsContext();
  const deleteAllFilters = () => {
    setBodyOverflowHidden(false);
    if (!allFacets) return;
    filterChangeByUserRef.current = true;
    const keys = [...Object.keys(allFacets), STOCK_FACET_KEY];
    deactivateFacets?.(keys as (keyof FacetsViewModel)[]);
  };
  return <Button size='xsmall' graphicStyle='text' className={className} onClick={deleteAllFilters} disabled={!anyFiltersApplied} icon={{
    position: 'right',
    element: <IconTrash className='h-5 w-5' />
  }} data-sentry-element="Button" data-sentry-component="RemoveAllFilters" data-sentry-source-file="remove-all-filters.tsx">
            حذف همه فیلترها
        </Button>;
}